// extracted by mini-css-extract-plugin
export default {"progress":"styles_progress__JC+-Y","progress-qh65fe":"styles_progress-qh65fe__BlHLl"};